
import { useState } from "react";
import { Menu, Button } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import icon1 from "../../assets/images/learn.svg";
import icon2 from "../../assets/images/sip.svg";
import icon3 from "../../assets/images/sector.svg";
import icon4 from "../../assets/images/index.svg";

import Dashboard01 from "../../assets/images/icon/dashboard.svg";

import User from "../../assets/images/icon/user.svg";
import Hotel from "../../assets/images/icon/hotel.svg";
import Goverment from "../../assets/images/icon/government.svg";
import Voucher from "../../assets/images/icon/voucher.svg";
import Authentication from "../../assets/images/icon/authentication.svg";
import CarType from "../../assets/images/icon/car-type.svg";
import CarMake from "../../assets/images/icon/car-make.svg";
import CarModel from "../../assets/images/icon/car-model.svg";
import Price01 from "../../assets/images/icon/price.svg";
import Discount01 from "../../assets/images/icon/discount.svg";
import Loyalty from "../../assets/images/icon/loyalty.svg";
import Order from "../../assets/images/icon/order.svg";
import Notification from "../../assets/images/icon/notification.svg";
import Transaction from "../../assets/images/icon/transaction.svg";
import Banner from "../../assets/images/icon/banner.svg";
import Content from "../../assets/images/icon/content.svg";
import Email from "../../assets/images/icon/email.svg";
import Profile from "../../assets/images/icon/profile.svg";
import Caricons from "../../assets/images/icon/car-icons.svg";
import lang from "../../helper/lang";

export const menuItems = [
  {
    key: "Dashboard",
    path: "/dashboard",
    icon: "fas fa-tachometer-alt",
    label: `${lang("Dashboard")}`
  },
  {
    key: "SubAdminSection",
    path: "/sub-admin",
    icon: "fas fa-user-cog",
    label: `${lang("Sub_Admin")} ${lang("Manager")}`
  },
  {
    key: "UserSubMenu",
    label: `${lang("User")} ${lang("Manager")}`,
    icon: "fas fa-users",
    children: [
      {
        key: "CustomerSection",
        path: "/user/customer",
        label: `${lang("Customer")} ${lang("Manager")}`
      },
      {
        key: "VendorSection",
        path: "/user/vendor",
        label: `${lang("Vendor")} ${lang("Manager")}`
      },
      // {
      //   key: "VendorStaffSection",
      //   path: "/user/vendor-staff",
      //   label: `${lang("Vendor")} ${lang("Staff")} ${lang("Manager")}`
      // }
    ]
  },
  {
    key: "DiscountSection",
    path: "/discount",
    icon: "fab fa-product-hunt",
    label: `${lang("Discount")} ${lang("Manager")}`
  },
  {
    key: "VenueSection",
    path: "/venue",
    icon: "fas fa-cube",
    label: `${lang("Venue")} ${lang("Manager")}`
  },
  {
    key: "EventSection",
    path: "/event",
    icon: "fas fa-cube",
    label: `${lang("Event")} ${lang("Manager")}`
  },
  {
    key: "NewsSection",
    path: "/news",
    icon: "fas fa-cube",
    label: `${lang("News")} ${lang("Manager")}`
  },
  {
    key: "BookingSection",
    path: "/booking",
    icon: "fas fa-cube",
    label: `${lang("Booking")} ${lang("Manager")}`
  },
  {
    key: "ContentSection",
    path: "/content",
    icon: "fa fa-file",
    label: `${lang("Content")} ${lang("Manager")}`
  },
  {
    key: "EmailSection",
    path: "/email-template",
    icon: "fas fa-envelope",
    label: `${lang("Email_Template")} ${lang("Manager")}`
  },
  {
    key: "NotificationSection",
    path: "/activity-notification",
    icon: "fas fa-bell",
    label: `${lang("Notification")} ${lang("Manager")}`
  },
  {
    key: "SettingSection",
    path: "/setting",
    icon: "fas fa-cog",
    label: `${lang("Setting")} ${lang("Manager")}`
  },
]

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  return (
    <>
      <div className="brand">
        <a href="/taxi-admin">
          <img src={logo} alt="" />
          <span>Taxi Panel</span>
        </a>
      </div>
      <hr />
      <Menu theme="light" mode="inline">
        <Menu.Item key="1">
          <NavLink to="/taxi-admin/dashboard">
            <span
              className="icon"
              style={{
                background: page === "taxi-admin/dashboard" ? color : "",
              }}
            >
              <img src={Dashboard01} />
            </span>
            <span className="label">Dashboard</span>
          </NavLink>
        </Menu.Item>

        <Menu.Item key="20">
          <NavLink to="/taxi-admin/sub-admin">
            <span
              className="icon"
              style={{
                background: page === "sub-admin" ? color : "",
              }}
            >
              <img src={User} />
            </span>
            <span className="label">Sub Admin Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="2">
          <NavLink to="/taxi-admin/user-manager">
            <span
              className="icon"
              style={{
                background: page === "user-manager" ? color : "",
              }}
            >
              <img src={User} />
            </span>
            <span className="label">User Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="6">
          <NavLink to="/taxi-admin/hotel-manager">
            <span
              className="icon"
              style={{
                background: page === "hotel-manager" ? color : "",
              }}
            >
              <img src={Hotel} />
            </span>
            <span className="label">Hotel Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="3">
          <NavLink to="/taxi-admin/goverment-manager">
            <span
              className="icon"
              style={{
                background: page === "goverment-manager" ? color : "",
              }}
            >
              <img src={Goverment} />
            </span>
            <span className="label">Government Official Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="4">
          <NavLink to="/taxi-admin/voucher-manager">
            <span
              className="icon"
              style={{
                background: page === "voucher-manager" ? color : "",
              }}
            >
              <img src={Voucher} />
            </span>
            <span className="label">Voucher Manager</span>
          </NavLink>
        </Menu.Item>

        <Menu.Item key="21">
          <NavLink to="/taxi-admin/driver-manager">
            <span
              className="icon"
              style={{
                background: page === "driver-manager" ? color : "",
              }}
            >
              <img src={Authentication} />
            </span>
            <span className="label">Driver Manager & Authentication</span>
          </NavLink>
        </Menu.Item>


        <Menu.SubMenu className="car-menagments" key="car-manager" title={<span className="main-caricon"><img src={Caricons} alt="Car Type" /> Car Manager</span>}>

          <Menu.Item key="7">
            <NavLink to="/taxi-admin/car-type-manager">
              <span
                className="icon"
                style={{
                  background: page === "car-type-manager" ? color : "",
                }}
              >
                <img src={CarType} alt="Car Type" />
              </span>
              <span className="label">Car-Type Manager</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="23">
            <NavLink to="/taxi-admin/car-make-manager">
              <span
                className="icon"
                style={{
                  background: page === "car-make-manager" ? color : "",
                }}
              >
                <img src={CarMake} alt="Car Make" />
              </span>
              <span className="label">Car-Make Manager</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="24">
            <NavLink to="/taxi-admin/car-model-manager">
              <span
                className="icon"
                style={{
                  background: page === "car-model-manager" ? color : "",
                }}
              >
                <img src={CarModel} alt="Car Model" />
              </span>
              <span className="label">Car-Model Manager</span>
            </NavLink>
          </Menu.Item>
        </Menu.SubMenu>

        <Menu.Item key="25">
          <NavLink to="/taxi-admin/user-car">
            <span
              className="icon"
              style={{
                background: page === "user-car" ? color : "",
              }}
            >
              <img src={Price01} />
            </span>
            <span className="label">User Car Manager</span>
          </NavLink>
        </Menu.Item>

        <Menu.Item key="8">
          <NavLink to="/taxi-admin/price-matrix-manager">
            <span
              className="icon"
              style={{
                background: page === "price-matrix-manager" ? color : "",
              }}
            >
              <img src={Price01} />
            </span>
            <span className="label">Price Matrix Manager</span>
          </NavLink>
        </Menu.Item>

        <Menu.Item key="9">
          <NavLink to="/taxi-admin/discount-manager">
            <span
              className="icon"
              style={{
                background: page === "discount-manager" ? color : "",
              }}
            >
              <img src={Discount01} />
            </span>
            <span className="label">Discount code manager</span>
          </NavLink>
        </Menu.Item>

        <Menu.Item key="11">
          <NavLink to="/taxi-admin/loyalty-point-manager">
            <span
              className="icon"
              style={{
                background: page === "loyalty-point-manager" ? color : "",
              }}
            >
              <img src={Loyalty} />
            </span>
            <span className="label">Loyalty Point Matrix Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="12">
          <NavLink to="/taxi-admin/order-manager">
            <span
              className="icon"
              style={{
                background: page === "order-manager" ? color : "",
              }}
            >
              <img src={Order} />
            </span>
            <span className="label">Order Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="13">
          <NavLink to="/taxi-admin/notification-manager">
            <span
              className="icon"
              style={{
                background: page === "notification-manager" ? color : "",
              }}
            >
              <img src={Notification} />
            </span>
            <span className="label">Notification Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="14">
          <NavLink to="/taxi-admin/transaction-manager">
            <span
              className="icon"
              style={{
                background: page === "transaction-manager" ? color : "",
              }}
            >
              <img src={Transaction} />
            </span>
            <span className="label">Transaction Summary</span>
          </NavLink>
        </Menu.Item>
        {/* <Menu.Item key="15">
          <NavLink to="/taxi-admin/banner-manager">
            <span
              className="icon"
              style={{
                background: page === "banner-manager" ? color : "",
              }}
            >
              <img src={Banner} />
            </span>
            <span className="label">Banner Manager</span>
          </NavLink>
        </Menu.Item> */}
        <Menu.Item key="16">
          <NavLink to="/taxi-admin/content-manager">
            <span
              className="icon"
              style={{
                background: page === "content-manager" ? color : "",
              }}
            >
              <img src={Content} />
            </span>
            <span className="label">Content Manager</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="17">
          <NavLink to="/taxi-admin/email-template-manager">
            <span
              className="icon"
              style={{
                background: page === "email-template-manager" ? color : "",
              }}
            >
              <img src={Email} />
            </span>
            <span className="label">Email Templates</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="5">
          <NavLink to="/taxi-admin/profile">
            <span
              className="icon"
              style={{
                background: page === "profile" ? color : "",
              }}
            >
              <img src={Profile} />
            </span>
            <span className="label">Profile</span>
          </NavLink>
        </Menu.Item>


      </Menu >

    </>
  );
}

export default Sidenav;
